module.exports = __webpack_public_path__ + "static/media/armadillo-booking-4.c00aea33.jpg";